// Form field constants for Tenancy Transfer Modal
export const FIELD_NAMES = {
  // Step 1 - Property Details
  ADDRESS: 'address',
  UNIT_NUMBER: 'unitNumber',
  STREET_NUMBER: 'streetNumber',
  STREET_NAME: 'streetName',
  SUBURB: 'suburb',
  STATE: 'state',
  POSTCODE: 'postcode',

  // Step 2 - Lease Details
  LEASE_START_DATE: 'leaseStartDate',
  WEEKLY_RENT: 'weeklyRent',

  // Step 3 - Contact Details
  EMAIL: 'email',
  MOBILE: 'mobile',
  FIRST_NAME: 'firstName',
  LAST_NAME: 'lastName',
  MESSAGE: 'message',
} as const

// Legacy compatibility - keeping formFields for existing references
export const formFields = {
  address: FIELD_NAMES.ADDRESS,
  unitNumber: FIELD_NAMES.UNIT_NUMBER,
  streetNumber: FIELD_NAMES.STREET_NUMBER,
  streetName: FIELD_NAMES.STREET_NAME,
  suburb: FIELD_NAMES.SUBURB,
  state: FIELD_NAMES.STATE,
  postcode: FIELD_NAMES.POSTCODE,
  leaseStartDate: FIELD_NAMES.LEASE_START_DATE,
  weeklyRent: FIELD_NAMES.WEEKLY_RENT,
  email: FIELD_NAMES.EMAIL,
  mobile: FIELD_NAMES.MOBILE,
  firstName: FIELD_NAMES.FIRST_NAME,
  lastName: FIELD_NAMES.LAST_NAME,
  message: FIELD_NAMES.MESSAGE,
}

// Step configuration
export const STEPS = [
  { id: 1, title: 'Property Details', progress: 33.33 },
  { id: 2, title: 'Lease Details', progress: 67 },
  { id: 3, title: 'Contact Details', progress: 100 },
]

// Form validation step arrays
export const STEP_1_FIELDS = [
  FIELD_NAMES.STREET_NUMBER,
  FIELD_NAMES.STREET_NAME,
  FIELD_NAMES.SUBURB,
  FIELD_NAMES.STATE,
  FIELD_NAMES.POSTCODE,
]

export const STEP_2_FIELDS = [
  FIELD_NAMES.LEASE_START_DATE,
  FIELD_NAMES.WEEKLY_RENT,
]

export const STEP_3_FIELDS = [FIELD_NAMES.EMAIL, FIELD_NAMES.MOBILE]

// Type for field names (for better TypeScript support)
export type FieldName = typeof FIELD_NAMES[keyof typeof FIELD_NAMES]

// Form values interface
export interface FormValues {
  // Step 1 - Property Details
  address: string | any // Can be string (typed) or object (selected from autocomplete)
  unitNumber: string
  streetNumber: string
  streetName: string
  suburb: string
  state: string
  postcode: string

  // Step 2 - Lease Details
  leaseStartDate: string
  weeklyRent: string

  // Step 3 - Contact Details
  email: string
  mobile: string
  firstName?: string
  lastName?: string
  message: string
}
